import * as React from 'react';
import type { match } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom';

import { CONNECT_ROUTES, SETTINGS_ROUTES } from '@/nav-routes';
import { useNavigate } from '@/router';

import { useAppLibraryContext } from './AppLibraryContext';

type UseAppRedirectReturnType = (label: string) => void;

const useAppRedirect = (): UseAppRedirectReturnType => {
  const navigate = useNavigate();

  return React.useCallback(
    (label: string) => {
      navigate.push(`${CONNECT_ROUTES.APP}/${label}`);
    },
    [navigate]
  );
};

const useOpenConnectApps = () => {
  const navigate = useNavigate();

  return React.useCallback(
    (page?: ConnectPage) => {
      if (page) {
        navigate.push(`${CONNECT_ROUTES.BASE_ROUTE}/${page}`);
      } else {
        navigate.push(CONNECT_ROUTES.BASE_ROUTE);
      }
    },
    [navigate]
  );
};

const useOpenChannels = (): (() => void) => {
  const navigate = useNavigate();

  return React.useCallback(() => {
    navigate.push(SETTINGS_ROUTES.CHANNELS);
  }, [navigate]);
};

const usePopperOpenConnectApps = () => {
  const { closePopper } = useAppLibraryContext();
  const openConnectApps = useOpenConnectApps();

  return (page?: ConnectPage) => {
    closePopper();
    openConnectApps(page);
  };
};

const useIsConnect = (): match<void> | null => {
  return useRouteMatch(CONNECT_ROUTES.BASE_ROUTE);
};

const useAppModalRouteMatch = (): match<{ app: string }> | null => {
  return useRouteMatch<{ app: string }>('/connect/app/:app');
};

const useBackToApps = (): (() => void) => {
  const navigate = useNavigate();

  return React.useCallback(() => {
    navigate.replace(CONNECT_ROUTES.BASE_ROUTE);
  }, [navigate]);
};

export type ConnectPage = 'app' | 'exchange' | 'website';

export {
  useAppRedirect,
  useBackToApps,
  useIsConnect,
  useAppModalRouteMatch,
  useOpenConnectApps,
  useOpenChannels,
  usePopperOpenConnectApps,
};
